import React from "react";
import { Link } from "react-router-dom";

const CharacterItem = ({ character }) => {
  const imageUrl =
    character.characterId?.images?.webp?.image_url ||
    character.characterId?.images?.webp?.imageUrl ||
    character.characterId?.images?.jpg?.image_url ||
    character.characterId?.images?.jpg?.imageUrl ||
    "/placeholder.jpg";
  const name = character.characterId?.name || "Unknown Character";
  const fromMedia = character.characterId?.from?.media || "";
  const hasNotes = !!character.notes;
  const characterId = character.characterId?.id;

  return (
    <Link to={`/characters/${characterId}`} className="favorite-item-link">
      <div className="favorite-item">
        <div className="favorite-thumb">
          <img src={imageUrl} alt={name} />
        </div>
        <div className="favorite-details">
          <h4 className="favorite-title">{name}</h4>
          <div className="favorite-meta">
            {fromMedia && <span className="favorite-type">{fromMedia}</span>}
            {hasNotes && (
              <span className="favorite-note" title={character.notes}>
                Has Notes
              </span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CharacterItem;
